import { s } from '@/features/integrations/guideStyles'
import type { GuideId } from '@/features/integrations/guides'

export function CurlSecretNote() {
  return (
    <p style={{ ...s.para, marginTop: 10 }}>
      Store the bot token's <strong>Client ID</strong> as <code style={s.code}>TM_CLIENT_ID</code> and its{' '}
      <strong>Client Secret</strong> as <code style={s.code}>TM_CLIENT_SECRET</code> - on GitHub under{' '}
      <strong>Settings → Secrets and variables → Actions</strong>, on GitLab under{' '}
      <strong>Settings → CI/CD → Variables</strong> (masked). The <code style={s.code}>client_id</code> in the
      grant is the fixed <code style={s.code}>terramantle-bots</code>, not a secret.
    </p>
  )
}

/** Shown under the `github` / `gitlab` tabs: the CLI needs no stored secret. */
export function CliCiNote({ onSwitchGuide }: { onSwitchGuide: (id: GuideId) => void }) {
  return (
    <p style={{ ...s.para, marginTop: 10 }}>
      No stored secret: <code style={s.code}>terramantle</code> detects the runner and authenticates with its
      ambient OIDC token. Claim the repository first under Organisation settings →{' '}
      <button style={s.linkBtn} onClick={() => onSwitchGuide('oidc-trust')}>Pipeline Trust</button>. <code style={s.code}>TERRAMANTLE_ORG</code> is required in CI - OIDC tokens carry no org lookup. On a
      runner without OIDC, set <code style={s.code}>TERRAMANTLE_CLIENT_ID</code> and{' '}
      <code style={s.code}>TERRAMANTLE_CLIENT_SECRET</code> and the CLI falls back to a bot token.
    </p>
  )
}

// ── Terramantle CLI: Getting Started ─────────────────────────────────────────

export type InstallMethod = 'brew' | 'shell' | 'source'

export const INSTALL_LABELS: Record<InstallMethod, string> = {
  brew:   'Homebrew',
  shell:  'Shell installer',
  source: 'From source',
}

